// Letters — letters.* (Correspondence)
// Backend keys registered by migration 2026_08_31_000005_add_letter_permissions.
// The ids are the central-assigned approval numbers (approved 2026-08-23). An id
// that does not equal its backend `permissions.id` fails SILENTLY —
// HAS_PERMISSION returns false, so the page, the sidebar leaf and every gated
// button never appear, with no error anywhere.

/** letters.index */
export const LETTERS_INDEX = 1474;
/** letters.show — no such key by convention; a detail view is guarded by index. */
export const LETTERS_SHOW = LETTERS_INDEX;
/** letters.create */
export const LETTERS_CREATE = 1476;
/** letters.update */
export const LETTERS_UPDATE = 1477;
/** letters.delete */
export const LETTERS_DELETE = 1478;
/** letters.restore */
export const LETTERS_RESTORE = 1479;
/** letters.submit_review */
export const LETTERS_SUBMIT_REVIEW = 1480;
/** letters.review */
export const LETTERS_REVIEW = 1481;
/** letters.submit_approval */
export const LETTERS_SUBMIT_APPROVAL = 1482;
/** letters.approve */
export const LETTERS_APPROVE = 1483;
/** letters.reject */
export const LETTERS_REJECT = 1484;
/** letters.issue */
export const LETTERS_ISSUE = 1485;
/** letters.print */
export const LETTERS_PRINT = 1486;
/** letters.download — its own key here, unlike modules that fold it into print. */
export const LETTERS_DOWNLOAD = 1487;
/** letters.send */
export const LETTERS_SEND = 1488;
/** letters.manage_types */
export const LETTERS_MANAGE_TYPES = 1489;
/** letters.manage_templates */
export const LETTERS_MANAGE_TEMPLATES = 1490;
/** letters.manage_settings */
export const LETTERS_MANAGE_SETTINGS = 1491;
/** letters.view_all — widens the register to the whole office (no route of its own). */
export const LETTERS_VIEW_ALL = 1492;
/** letters.view_department — widens the register to the user's team-mates. */
export const LETTERS_VIEW_DEPARTMENT = 1493;
